import { isDevMode } from '@angular/core';
import { DiagLogLevel } from '@opentelemetry/api';
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions';
import packageJson from '@vmspdb/package-json';
import { TelemetryConfig } from '@vmspdb/ui/common';

export const environment = {
  dropboxKey: 'zua6ba5pkfjgqd3',
  mapId: '',
  firebase: {
    projectId: '',
    appId: '',
    storageBucket: '',
    locationId: '',
    apiKey: '',
    authDomain: '',
    messagingSenderId: '',
  },
  useEmulators: false,
  production: !isDevMode(),
  opentelemetry: {
    enabled: false,
    commonConfig: {
      console: false, // Display trace on console
      production: true, // Send Trace with BatchSpanProcessor (true) or SimpleSpanProcessor (false)
      serviceName: 'vmspdb-frontend', // Service name send in trace
      logBody: true, // true add body in a log, nothing otherwise
      probabilitySampler: '0.75', // 75% sampling
      logLevel: DiagLogLevel.ALL, //ALL Log, DiagLogLevel is an Enum from @opentelemetry/api
      resourceAttributes: {
        // extra resource attributes like service.namespace
        [ATTR_SERVICE_NAME]: 'vmspdb-frontend',
        'service.namespace': 'prod',
        [ATTR_SERVICE_VERSION]: packageJson.version,
      },
    },
    // otelcolConfig: {
    //   url: 'https://ingest.lightstep.com:443/traces/otlp/v0.9', // URL of opentelemetry collector
    //   headers: {
    //     'lightstep-access-token':
    //       'qnKrJCyCidZlBbaHLFj7G4HxFlwj2kkDRbpWEiWUlCh3W6GNwG7tSVPEouA46r0M3s6OA7yjmQBDK9sM8c6UvVIj4ITy13vrAdIIgvUE',
    //   },
    //   timeoutMillis: '10000',
    // },
    otelcolConfig: {
      timeoutMillis: '10000',
    },
    loggerConfig: {
      // level: NgxLoggerLevel.DEBUG,
      disableConsoleLogging: false,
    },
  } as TelemetryConfig,
};
